import React, { useEffect, useState } from 'react';
import { DataTable } from '@uhg-abyss/web/ui/DataTable';
import { useSelector } from 'react-redux';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useDataTable } from '@uhg-abyss/web/hooks/useDataTable';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { event } from '@uhg-abyss/web/tools/event';
import { Link } from '@uhg-abyss/web/ui/Link';
import PropTypes from 'prop-types';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { LagoonContext } from '@src/AppContext';
import apiData from './OrganizationListReviewUrl.json';
import 'regenerator-runtime/runtime';
import { constants } from '@src/common/Utils/Constants';
import HealthCheckMapping from './HealthCheckMapping.json';

const Wrapper = styled('div', {});

const AccordianLinks = styled('div', {
  display: 'grid',
});

const ApiStatusStyles = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '2px 8px',
  gap: '8px',

  '@screen >= $xs': {
    padding: '10px',
  },

  '@screen >= $sm': {
    padding: '10px',
  },
});

const ApiCategoryStyles = styled('div', {
  width: '100%',
});

const DisplayFlex = styled('div', {
  display: 'flex',
});

const IconPadding = styled('div', {
  marginTop: '2px',
  padding: '0px 10px',
  marginLeft: '2px',
});

const UpdatedDate = styled('p', {
  color: '#424242',
  fontSize: '$sm',
  fontWeight: '$normal',
  minHeight: '20px',
  lineHeight: '20px',
  display: 'flex',
  marginBottom: '0px',
});

const StyledLink = styled(Link, {});

const AccordianLink = styled('div', {});

export const OrganizationList = ({ orgUserInfo }) => {
  const [date, setDate] = useState('');
  const healthCheckApiData = useSelector((state) => {
    return state.GET_API_HEALTH_CHECK;
  });
  const healthCheckData = healthCheckApiData?.data;
  const { navigate } = useRouter();
  const lagoonContext = React.useContext(LagoonContext);

  const featureToggles = lagoonContext?.getTable('feature-toggles');
  const providerAccessToggle = featureToggles?.getRow(
    'PROVIDER_ACCESS_TOGGLE'
  )?.enabled;

  const getApiEnvironment = (row) => {
    return (
      <Wrapper>
        {row.includes('Production') && (
          <ApiStatusStyles>{row[1]}</ApiStatusStyles>
        )}
        {row.includes('Staging') && <ApiStatusStyles>{row[0]}</ApiStatusStyles>}
      </Wrapper>
    );
  };

  const columns = [
    {
      header: <span style={{ fontSize: '13px' }}>Product Name</span>,
      accessorKey: 'apiCategory',
      cell: (info) => {
        return info.getValue();
      },
    },
    {
      header: <span style={{ fontSize: '13px' }}>Environment</span>,
      accessorKey: 'environment',
      cell: (info) => {
        return info.getValue();
      },
    },
    {
      header: <span style={{ fontSize: '13px' }}>Status</span>,
      accessorKey: 'status',
      cell: (info) => {
        return info.getValue();
      },
    },
  ];

  const getApiCategory = (row) => {
    const apiInfo = apiData && apiData[row?.replace(/\s+/g, '').toLowerCase()];
    const interactionName = apiInfo?.name;
    const interactionContext = 'product link clicks';
    const feedbackRoute = `/welcome/${row
      ?.replace(/\s+/g, '')
      ?.toLowerCase()}-feedback`;
    const getReviewApi = (apiLink) => {
      const interactionValue = 'review api';
      event('INTERACTION_EVENT', {
        interactionName,
        interactionValue,
        interactionContext,
      });
      navigate(apiLink);
    };
    const getReleaseNote = (releaseNoteLink) => {
      const interactionValue = 'release notes';
      event('INTERACTION_EVENT', {
        interactionName,
        interactionValue,
        interactionContext,
      });
      navigate(releaseNoteLink);
    };
    const getFeedBackPage = () => {
      const interactionValue = 'api feedback';
      event('INTERACTION_EVENT', {
        interactionName,
        interactionValue,
        interactionContext,
      });
      navigate(feedbackRoute);
    };
    return (
      <ApiCategoryStyles>
        <Accordion
          type="multiple"
          isCollapsible={true}
          key={apiInfo?.name}
          style={{
            backgroundColor: 'inherit',
            width: '100%',
            height: 'auto',
            overflow: 'visible',
            // minHeight: '200px',
          }}
          css={{
            '.abyss-accordion-content': {
              overflow: 'hidden',
            },
            '.abyss-accordion-content[data-state="open"]': {
              height: 'auto',
              overflow: 'visible',
            },
            '.abyss-accordion-content-text': {
              whiteSpace: 'normal',
              overflow: 'visible',
            },
            '.abyss-accordion-header-trigger': {
              border: 'none',
            },
            '.abyss-accordion-content-container': {
              border: 'none',
            },
            '.abyss-accordion-header': {
              fontSize: '14px',
              fontFamily: 'AbyssUHCSerif, Georgia Bold, serif',
            },
            '.abyss-link-root': {
              fontSize: '13px !important',
            },
          }}
        >
          <Accordion.Item value={apiInfo?.name}>
            <Accordion.Header>
              {apiInfo?.serviceName === 'Superconnector'
                ? `Super Connector  ${apiInfo?.name}`
                : apiInfo?.name}
            </Accordion.Header>
            <Accordion.Content style={{ backgroundColor: 'inherit' }}>
              <AccordianLinks>
                <AccordianLink>
                  <StyledLink
                    size="md"
                    fontWeight="regular"
                    onClick={() => {
                      return getReviewApi(apiInfo?.technicalDetailsPage);
                    }}
                  >
                    Review API
                  </StyledLink>
                </AccordianLink>
                <AccordianLink>
                  <StyledLink
                    size="md"
                    fontWeight="regular"
                    onClick={() => {
                      return getFeedBackPage();
                    }}
                  >
                    API Feedback
                  </StyledLink>
                </AccordianLink>
                {apiInfo?.releaseNotesPage && (
                  <AccordianLink>
                    <StyledLink
                      size="md"
                      fontWeight="regular"
                      onClick={() => {
                        return getReleaseNote(apiInfo?.releaseNotesPage);
                      }}
                    >
                      Release Notes
                    </StyledLink>
                  </AccordianLink>
                )}
              </AccordianLinks>
            </Accordion.Content>
          </Accordion.Item>
        </Accordion>
      </ApiCategoryStyles>
    );
  };

  const getSortedDataList = (data) => {
    if (data) {
      const apiSortedData = [...data];
      return apiSortedData?.sort((a, b) => {
        return a.localeCompare(b);
      });
    }
    return [];
  };

  let stageList = orgUserInfo.linkedApis?.stage || [];
  stageList = providerAccessToggle
    ? stageList
    : stageList.filter((item) => {
        return item !== 'Provider Access';
      });
  const stageApiList = getSortedDataList(stageList);

  const getApiStatus = (item, row) => {
    const api = HealthCheckMapping[item] || item;
    let stageColor = 'neutral';
    let stageStatusValue = 'Fetching status';
    if (healthCheckData?.stage?.[api] != null) {
      stageColor = healthCheckData?.stage[api] === 200 ? 'success' : 'error';
      stageStatusValue = stageColor === 'success' ? 'Operational' : 'Outage';
    }

    let prodColor = 'neutral';
    let prodStatusValue = 'Fetching status';
    if (healthCheckData?.prod?.[api] != null) {
      prodColor = healthCheckData?.prod[api] === 200 ? 'success' : 'error';
      prodStatusValue = prodColor === 'success' ? 'Operational' : 'Outage';
    }

    // The following APIs are super connectors and their operational status is hardcoded to 'Operational'
    // because still the helthcheck need to implement for these apis, once implemented we can remove this condition.

    if (constants.SUPER_CONNECTOR_APIS.includes(item)) {
      prodColor = 'success';
      stageColor = 'success';
      stageStatusValue = 'Operational';
      prodStatusValue = 'Operational';
    }

    if (healthCheckApiData?.error) {
      stageColor = 'warning';
      stageStatusValue = 'Not available';
      prodColor = 'warning';
      prodStatusValue = 'Not available';
    }

    return (
      <Wrapper>
        {row.includes('Production') && (
          <ApiStatusStyles>
            <Badge
              rounded
              variant={prodColor}
              css={{
                'abyss-badge-content': {
                  fontSize: '13px !important',
                },
              }}
            >
              {prodStatusValue}
            </Badge>
          </ApiStatusStyles>
        )}
        {row.includes('Staging') && (
          <ApiStatusStyles>
            <Badge
              rounded
              variant={stageColor}
              css={{
                'abyss-badge-content': {
                  fontSize: '13px !important',
                },
              }}
            >
              {stageStatusValue}
            </Badge>
          </ApiStatusStyles>
        )}
      </Wrapper>
    );
  };

  const dataList =
    stageApiList.length > 0
      ? stageApiList.map((item, index) => {
          const status = ['Staging'];
          const prodList = orgUserInfo.linkedApis?.prod;
          if (prodList?.includes(item)) {
            status.push('Production');
          }
          const data = {
            uniqueId: `${item.replace(/\s+/g, '_').toLowerCase()}_${index}`,
            apiCategory: getApiCategory(item),
            environment: getApiEnvironment(status),
            status: getApiStatus(item, status),
          };
          return data;
        })
      : [];

  const lastUpdatedText = () => {
    return (
      <DisplayFlex>
        <IconPadding>
          <IconSymbol icon="update" size={16} />
        </IconPadding>
        <UpdatedDate style={{ fontSize: '13px' }}>
          last updated {date}
        </UpdatedDate>
      </DisplayFlex>
    );
  };

  const dataTableProps = useDataTable({
    paginationConfig: {
      enablePagination: true,
      paginationSizeOptions: [10],
    },
    initialData: dataList,
    initialColumns: columns,
    rowIdKey: 'uniqueId',
    additionalPaginationText: lastUpdatedText(),
  });

  useEffect(() => {
    dataTableProps.setData(dataList);

    setDate(healthCheckApiData?.lastUpdatedDate);
  }, [healthCheckApiData]);

  return (
    <Wrapper>
      <DataTable
        title={
          <span style={{ fontSize: '19px' }}>Your Organization's APIs</span>
        }
        tableState={dataTableProps}
        css={{
          '.abyss-data-table-container': {
            border: 'none !important',
          },
          '.abyss-data-table-row': {
            height: 'auto',
          },
          '.abyss-data-table-cell': {
            fontSize: '13px !important',
          },
        }}
      >
        <DataTable.Table />
        <DataTable.SlotWrapper>
          <DataTable.Pagination />
        </DataTable.SlotWrapper>
        {lastUpdatedText()}
      </DataTable>
    </Wrapper>
  );
};

OrganizationList.propTypes = {
  orgUserInfo: PropTypes.shape({
    linkedApis: PropTypes.shape({
      stage: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
};
